import React from "react";
import LegalLayout, { H2, H3, P, UL } from "./LegalLayout";
import SEO from "../components/SEO";

const UPDATED = "13 octombrie 2026";

export default function TermsConditions() {
  return (
    <>
      <SEO
        title="Termeni și condiții | FPED"
        description="Termenii și condițiile programului «Introducere în Inteligența Artificială pentru educație» oferit de Fundația pentru Educație Digitală pe ai.fped.org."
        canonical="https://ai.fped.org/termeni-conditii"
      />
      <LegalLayout
        title="Termeni și condiții"
        lastUpdated={UPDATED}
        testid="terms-page"
        intro={`Acești Termeni și Condiții reglementează relația dintre Fundația pentru Educație Digitală și utilizatorii landing page-ului ai.fped.org, precum și înscrierea la programul «Introducere în Inteligența Artificială pentru educație: pregătire, predare și evaluare asistate de AI».`}
      >
      <H2>1. Părțile</H2>
      <P>
        <strong>Furnizorul</strong>: Fundația pentru Educație Digitală, sediu social în
        București, Sectorul 1, Str. Ioan Bianu Nr. 27, CIF 43506207 (denumită în continuare „Fundația").
      </P>
      <P>
        <strong>Utilizatorul / Cursantul</strong>: persoană fizică majoră, în general cadru
        didactic sau personal didactic auxiliar, care își manifestă interesul față de program
        sau care se înscrie efectiv la curs.
      </P>

      <H2>2. Obiectul</H2>
      <P>
        Obiectul îl constituie furnizarea programului „Introducere în Inteligența
        Artificială pentru educație: pregătire, predare și evaluare asistate de AI", cu o durată
        totală de <strong>25 de ore</strong>, structurat în 10 module de învățare. Cursul include
        <strong> 15 ore de sesiuni live cu instructor</strong>, desfășurate online în format
        meeting (teorie, demonstrații și exemple practice), plus <strong>10 ore de muncă
        individuală</strong> pentru aplicarea practică a noțiunilor învățate. Programul este
        <strong> acreditat prin OMEC nr. 4712/19.08.2026</strong>.
      </P>

      <H2>3. Înscriere și plată</H2>
      <UL>
        <li>Înscrierea se face online, prin completarea formularului de comandă disponibil pe site.</li>
        <li>Prețul afișat include TVA (dacă este aplicabil) și se achită integral, prin card bancar, inclusiv prin cardul Prima de carieră didactică.</li>
        <li>Plata este procesată în condiții de siguranță prin <strong>Netopia Payments</strong> sau <strong>EuPlătesc</strong>, în funcție de procesatorul de plăți selectat la momentul tranzacției. Fundația nu stochează datele cardului.</li>
        <li>După confirmarea plății, cursantul primește pe email factura, datele de acces și instrucțiunile pentru începerea cursului.</li>
      </UL>

      <H2>4. Drept de retragere (consumatori)</H2>
      <P>
        În calitate de consumator, ai dreptul de a te retrage din contract în termen de
        <strong> 14 zile calendaristice</strong> de la data confirmării comenzii, fără a invoca
        un motiv, conform <strong>OUG 34/2014</strong>.
      </P>
      <P>
        Excepție: în cazul conținutului digital furnizat altfel decât pe un suport material,
        dreptul de retragere se pierde dacă executarea a început cu acordul tău expres prealabil
        și ai luat la cunoștință că îți pierzi dreptul de retragere odată cu începerea
        executării (art. 16 lit. m din OUG 34/2014). În cazul în care nu ai accesat o parte
        semnificativă din materialele cursului, retragerea este posibilă în cele 14 zile.
      </P>
      <P>
        Pentru a exercita dreptul de retragere, trimite o solicitare clară la
        <a href="mailto:contact@fped.org" className="text-[#965EA7] underline"> contact@fped.org</a>.
        Rambursarea se efectuează în termen de cel mult 14 zile, prin aceeași metodă de plată.
      </P>
      <P>
        Pentru comenzile achitate cu cardul Prima de Carieră Didactică, rambursarea se
        efectuează numai în măsura permisă de regulile aplicabile acestui card și de
        condițiile Pluxee. Sumele disponibile pe card au destinație specială, conform
        <strong> OUG nr. 58/2023</strong>, iar retragerea sau preschimbarea în numerar
        este interzisă.
      </P>

      <H2>5. Livrarea serviciului</H2>
      <UL>
        <li>Cursul se livrează 100% online: 15 ore sesiuni live cu instructor (format meeting) + 10 ore de muncă individuală, prin intermediul platformei dedicate.</li>
        <li>Accesul la materiale este garantat pentru o perioadă de <strong>12 luni</strong> de la data înscrierii.</li>
        <li>Cursantul va putea descărca șabloane, materiale suport și certificat de absolvire la finalizarea cursului și a proiectului final.</li>
      </UL>

      <H2>6. Cont și siguranța accesului</H2>
      <P>
        Cursantul este responsabil de păstrarea confidențialității credențialelor de acces și
        de utilizarea contului. Distribuirea materialelor către terțe persoane sau partajarea
        contului sunt interzise și pot duce la suspendarea accesului fără rambursare.
      </P>

      <H2>7. Drepturi de proprietate intelectuală</H2>
      <P>
        Toate materialele cursului (video, fișe, șabloane, prezentări) sunt proprietatea
        intelectuală a Fundației sau a colaboratorilor săi și sunt furnizate strict pentru
        uzul personal al cursantului. Reproducerea, redistribuirea, comercializarea sau
        publicarea fără acord scris sunt interzise.
      </P>

      <H2>8. Responsabilități</H2>
      <UL>
        <li>Fundația depune toate eforturile rezonabile pentru ca platforma să fie disponibilă continuu, cu excepția întreruperilor programate sau cauzate de evenimente independente de voință.</li>
        <li>Fundația nu garantează rezultate specifice (ex.: aplicarea instrumentelor AI într-o școală anume), întrucât rezultatele depind de implicarea cursantului și de contextul școlar.</li>
        <li>Răspunderea Fundației este limitată la valoarea sumei plătite de cursant pentru curs.</li>
      </UL>

      {/* Validated by FPED on 13.10.2026. The emails that carry a referral
          code point here ("Condițiile sunt în Termeni și condiții, la
          „Recomandări”"), so the heading keeps this name. */}
      <H2>9. Recomandări</H2>
      <P>
        Cursanții care și-au plătit singuri locul la program, într-o grupă deschisă pe site,
        pot primi pe email un cod personal de recomandare. Nu primesc cod cursanții din grupele
        organizate pentru o instituție și nici cei al căror loc este plătit de o instituție.
      </P>
      <UL>
        <li><strong>Cum se folosește codul.</strong> Persoana recomandată trece codul în formularul de înscriere de pe site. Codul nu poate fi folosit de cursantul căruia îi aparține.</li>
        <li><strong>Când contează o recomandare.</strong> O recomandare este luată în calcul după ce persoana recomandată a plătit, iar plata a fost confirmată.</li>
        <li><strong>Beneficiul.</strong> Beneficiul, numărul de persoane recomandate necesar pentru a-l primi și data până la care poate fi folosit codul sunt cele comunicate în emailul prin care ai primit codul. Se acordă un singur beneficiu pentru fiecare cursant, oricâte persoane ar recomanda. Beneficiul nu se preschimbă în bani.</li>
        <li><strong>Acordarea.</strong> Fundația verifică recomandările înainte de a acorda beneficiul și îl poate refuza în caz de abuz, de exemplu înscrieri făcute de aceeași persoană cu adrese diferite sau plăți rambursate.</li>
        <li><strong>Ce află cel care recomandă.</strong> Cursantul care te-a recomandat este anunțat că te-ai înscris cu codul lui și îți vede numele.</li>
        <li><strong>Modificări.</strong> Fundația poate modifica sau opri oricând programul de recomandări. Codurile deja trimise își păstrează condițiile comunicate odată cu ele.</li>
      </UL>

      <H2>10. Modificarea Termenilor</H2>
      <P>
        Putem actualiza Termenii pentru a reflecta îmbunătățiri ale serviciului, modificări
        legale sau schimbări de funcționalitate. Versiunea curentă este afișată întotdeauna pe
        această pagină, împreună cu data ultimei actualizări. Modificările semnificative vor fi
        comunicate prin email cursanților activi.
      </P>

      <H2>11. Soluționarea litigiilor</H2>
      <P>
        Orice litigiu se va soluționa pe cale amiabilă. În caz contrar, este competentă
        instanța de la sediul Fundației, conform legislației române. Consumatorii pot apela și
        la <a href="https://anpc.ro" className="text-[#965EA7] underline" target="_blank" rel="noopener noreferrer">ANPC</a>{" "}
        sau la platforma europeană de soluționare alternativă a litigiilor{" "}
        <a className="text-[#965EA7] underline" href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">SOL</a>.
      </P>

      <H2>12. Contact</H2>
      <P>
        Pentru orice întrebare privind acești Termeni, contactează-ne la
        <a href="mailto:contact@fped.org" className="text-[#965EA7] underline"> contact@fped.org</a>.
      </P>
    </LegalLayout>
    </>
  );
}
